import { FormBuilder } from "components/form/FormBuilder";
import React from "react";

import { i18nService } from "services";
import { ActiveToolFacetType, IToolFacet } from "types";

import { makeSchema } from "./formSchema";

interface ToolQuickSearchFormProps {
  facets: IToolFacet[];
  onSubmit: (data: ActiveToolFacetType) => void;
  isLoading?: boolean;
}

export const ToolQuickSearchForm: React.FC<ToolQuickSearchFormProps> = ({
  facets,
  onSubmit,
  isLoading,
}) => {
  return (
    <div className="tool-quick-search-form">
      <FormBuilder
        {...makeSchema(facets)}
        submitLabel={i18nService.copy["toolQuickSearch.showTools"]}
        onFormSubmit={onSubmit}
        isSubmitting={isLoading}
        autoComplete="off"
      />
    </div>
  );
};
